var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99975 8.23388C10.0664 8.23388 11.7417 6.55856 11.7417 4.49194C11.7417 2.42532 10.0664 0.75 7.99975 0.75C5.93314 0.75 4.25781 2.42532 4.25781 4.49194C4.25781 6.55856 5.93314 8.23388 7.99975 8.23388Z",
    stroke: "#424242",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.25C14 12.4886 11.3137 10.25 8 10.25C4.68629 10.25 2 12.4886 2 15.25",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthUserIcon);
export default __webpack_public_path__ + "static/media/auth-user-icon.c60a9b2dbc643efab73e217be7b891d8.svg";
export { ForwardRef as ReactComponent };